class CountdownTimer {
  constructor(containerId) {
    this.container = document.getElementById(containerId);
    this.date = this.container.dataset.date;
    this.time = this.container.dataset.time;
    this.targetTime = new Date(`${this.date}T${this.time}:00`).getTime();

    // Get individual digit elements
    this.daysDigits = this.container.querySelectorAll("#days .time");
    this.hoursDigits = this.container.querySelectorAll("#hours .time");
    this.minutesDigits = this.container.querySelectorAll("#minutes .time");
    this.secondsDigits = this.container.querySelectorAll("#seconds .time");

    this.init();
  }

  init() {
    this.update();
    this.timer = setInterval(() => this.update(), 1000);
  }

  update() {
    const now = new Date().getTime();
    const distance = this.targetTime - now;

    if (distance <= 0) {
      this.updateDigits(this.daysDigits, "00");
      this.updateDigits(this.hoursDigits, "00");
      this.updateDigits(this.minutesDigits, "00");
      this.updateDigits(this.secondsDigits, "00");
      clearInterval(this.timer);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.updateDigits(this.daysDigits, this.pad(days));
    this.updateDigits(this.hoursDigits, this.pad(hours));
    this.updateDigits(this.minutesDigits, this.pad(minutes));
    this.updateDigits(this.secondsDigits, this.pad(seconds));
  }

  updateDigits(digitElements, value) {
    const digits = value.toString().padStart(2, '0').split('');
    digitElements.forEach((el, index) => {
      el.textContent = digits[index] || '0';
    });
  }

  pad(num) {
    return num < 10 ? `0${num}` : num;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CountdownTimer('countdown');
});